import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import Navbar from "@/components/Navbar";
import RideForm from "@/components/RideForm";
import { toast } from "sonner";

export default function Publish() {
  const nav = useNavigate();

  const submit = async (payload) => {
    try {
      const { data } = await api.post("/rides", payload);
      toast.success("Giro pubblicato!");
      nav(`/ride/${data.ride_id}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <>
      <Navbar />
      <main className="max-w-5xl mx-auto px-4 md:px-8 py-8">
        <div className="mb-8">
          <div className="label-tag mb-2">Pubblicazione giro</div>
          <h1 className="font-display font-black text-3xl md:text-4xl uppercase tracking-tighter text-gray-900">
            Crea un nuovo giro
          </h1>
          <p className="text-gray-500 mt-2 text-sm">Più dettagli inserisci, più compagni adatti troverai.</p>
        </div>

        <RideForm
          submitLabel="Pubblica giro"
          submittingLabel="Pubblicazione..."
          onSubmit={submit}
          onCancel={() => nav(-1)}
          testIdPrefix="publish"
        />
      </main>
    </>
  );
}
